import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function CommentIcon({ className, width = 18, height = 18 }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={cn('currentColor fill-current', className)}
            xmlns='http://www.w3.org/2000/svg'
            id='Layer_1'
            data-name='Layer 1'
            viewBox='0 0 24 24'
        >
            <path d='m13,12c0,.552-.448,1-1,1s-1-.448-1-1,.448-1,1-1,1,.448,1,1Zm4-1c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Zm-10,0c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Zm17,1.355v6.963c0,2.582-2.1,4.682-4.682,4.682h-6.186C6.103,24,.47,19.208.029,12.855c-.241-3.477,1.027-6.878,3.479-9.334C5.96,1.065,9.36-.204,12.837.028c6.26.425,11.163,5.84,11.163,12.327Zm-1,0c0-5.963-4.494-10.939-10.23-11.329-.251-.017-.503-.026-.753-.026-2.922,0-5.729,1.154-7.8,3.227C1.968,6.479.806,9.598,1.027,12.786c.41,5.918,5.501,10.214,12.105,10.214h6.186c2.03,0,3.682-1.651,3.682-3.682v-6.963Z' />
        </svg>
    );
}

export default CommentIcon;

